import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedSegment: { departureStation: {}, arrivalStation: {}, zone: {} },
    segments: [],
  }),

  mutations: {
    setSelectedSegment(state, segment) {
      Vue.set(state, "selectedSegment", segment);
    },
    setSegments(state, segments) {
      segments = segments.sort((s1, s2) => {
        return s1.lineOrder - s2.lineOrder;
      });
      Vue.set(state, "segments", segments);
    },
    setDefaultSegmentModule(state, segments) {
      Vue.set(state, "selectedSegment", { departureStation: {}, arrivalStation: {}, zone: {} });
      Vue.set(state, "segments", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createSegment: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/segments/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    // loadSegments: (context) => {
    //     return axios.get(context.getters.getMcServiceUrl+'/segments/item')
    //         .then((response) => {
    //             //TODO: This is temporary code, must be another way to do it.
    //
    //             let segments = response.data;
    //             for(let i=0 ; i < segments.length; i++){
    //                 segments[i].checkbox = false;
    //             }
    //             context.commit("setSegments",segments)
    //             return segments;
    //         });
    // },
    loadSegments: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/entity").then((response) => {
        context.commit("setSegments", response.data);
        // TODO: Inspect logic below
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadPublishedSegments: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/entity/published").then((response) => {
        //TODO: This is temporary code, must be another way to do it.
        let segments = response.data;
        for (let i = 0; i < segments.length; i++) {
          segments[i].checkbox = false;
        }
        return segments;
      });
    },
    loadSegment: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/entity/" + request.id).then((response) => {
        context.commit("setSelectedSegment", response.data);
      });
    },
    loadSegmentsByLineId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/line/" + request.id).then((response) => {
        // context.commit("setSegments",response.data);
        return response.data;
      });
    },

    loadSegmentHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/segments/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedSegmentHistory: (context, segment) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/history/" + segment.id, {}).then((response) => {
        return response.data;
      });
    },

    searchSegmentByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/segments/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteSegment: (context, segment) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/segments/entity/" + segment.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          segment.intents = intents;
          segment.intentId = response.data.id;
          return segment;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSegment: (context, segment) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/segments/draft/" + segment.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishSegment: (context, segment) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/publish/" + segment.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectSegment: (context, segment) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/reject/" + segment.intentId).then((response) => {
        helper.recallOrRejectEntity(segment, "segment");
        return response.data;
      });
    },

    recallSegment: (context, segment) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/recall/" + segment.intentId).then((response) => {
        helper.recallOrRejectEntity(segment, "segment");
        return response.data;
      });
    },

    sendToApprovalSegments: (context, segment) => {
      return axios.get(context.getters.getMcServiceUrl + "/segments/sendToApproval/" + segment.intentId).then((response) => {
        if (segment.intents[0].type === "CREATE_SEGMENT") {
          segment.intents[0].status = "WAITING_APPROVAL";
        } else if (segment.intents[0].type === "UPDATE_SEGMENT") {
          segment.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
  },
  getters: {
    getSelectedSegment: (state) => {
      return state.selectedSegment;
    },
    getSegments: (state) => {
      return state.segments;
    },
    getPublishedSegments: (state) => {
      return state.segments.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
